import styled from 'styled-components'
import Botao from '../Mantine/Botao'
import { DragOverlay } from '@dnd-kit/core'

export const QuickButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow-x: hidden;
  min-width: 0;
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 0 12px 12px;
  border-radius: 8px;
  overflow-x: hidden;
  min-width: 0;
`

export const Title = styled.h3`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: ${({ theme }) => theme.cor48} !important;
  margin: 0;
`

export const Description = styled.p`
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.cor48} !important;
  margin: 0;
  letter-spacing: 0.15px;
  margin-bottom: 12px;

  strong {
    color: ${({ theme }) => theme.cor54};
  }
`

export const TitleWithButton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 8px;
  margin: ${({ $margin }) => $margin ? `${$margin}` : '0'};

  span{
    margin-top: 42px !important;
  }
`

export const SectionTitle = styled.h4`
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: ${({ theme }) => theme.cor9} !important;
  margin: 0;
`

export const SectionTransition = styled.div`
  opacity: ${({ $isTransitioning }) => ($isTransitioning ? 0.5 : 1)};
  pointer-events: ${({ $isTransitioning }) =>
    $isTransitioning ? 'none' : 'auto'};
  transition: opacity 0.3s ease;
`

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column; 
  align-items: flex-start;
`

export const EmptyStateCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 16px;  
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.cor66};
  min-height: 114px;
  text-align: center;
`

export const EmptyStateText = styled.p`
  font-size: 16px;
  font-weight: 700;
  line-height: 24px;
  color: ${({ theme }) => theme.cor54}!important;
  margin: 0;
  letter-spacing: 0.15px;
`

export const EmptyFilteredText = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 18px;
  text-align: center;
  color: ${({ theme }) => theme.cor54}!important;
  font-size: 14px;
`

export const SubtleButton = styled(Botao)`
  padding: 0 !important;
  min-width: auto !important;
  height: 32px !important;

  .mantine-Button-label {
    font-size: 14px !important;
    line-height: 20px !important;
    font-weight: 600 !important;
  }
`

export const DragOverlayOverlay = styled(DragOverlay)`
  opacity: 0.85;
`

export const ContentScroll = styled.div`
  display: flex;
  flex-direction: column;
  max-height: 580px;
  overflow-y: auto;
  padding-right: 8px;
`

export const AvailableList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const AvailableItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  border: 1px solid ${({ theme }) => theme.cor73};
  border-radius: 8px;
  background-color: ${({ theme }) => theme.cor27};
  padding: 12px 24px;
`

export const AvailableItemName = styled.p`
  margin: 0;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.15px;
  color: ${({ theme }) => theme.cor54};
`

export const SearchIcon = styled.img`
  width: 16px;
  height: 16px;
  object-fit: contain;
`
